module.exports = __webpack_public_path__ + "img/5.cda3790c.jpg";